'use client';

import type { NewsletterFormFragment } from '@mnd-apps/public/wp-generated/types';
import { SPACING_2, SPACING_4, SPACING_6, SPACING_10 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import NewsletterSignupForm from './NewsletterSignupForm';

const NEWSLETTER_MODULE_WIDTH = '31.25rem';

const Title = styled.h2`
  // token: web/subheading/mobile
  font-size: 1.125rem;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: -0.03375rem;

  @media (min-width: ${NEWSLETTER_MODULE_WIDTH}) {
    // token: web/subheading/desktop
    font-size: 1.375rem;
    line-height: 1.65rem;
    letter-spacing: -0.04125rem;
  }
`;

const Container = styled.div`
  display: flex;
  gap: ${SPACING_2};
  flex-direction: column;
  align-items: center;
  justify-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: ${SPACING_6} ${SPACING_2};
  margin: 0;

  @media (min-width: calc(${NEWSLETTER_MODULE_WIDTH} + ${SPACING_4})) {
    width: ${NEWSLETTER_MODULE_WIDTH};
    margin: ${SPACING_10} auto;
    padding: 0;
  }
`;

const NewsLetterSignupModule = ({
  moduleData,
}: {
  moduleData: NewsletterFormFragment;
}) => {
  return (
    <Container>
      <Title>{moduleData.title}</Title>
      <NewsletterSignupForm hubspotFormId={moduleData.hubspotFormId ?? ''} />
    </Container>
  );
};

export default NewsLetterSignupModule;
